import { render, staticRenderFns } from "./TeachRoomSiZheng2.vue?vue&type=template&id=ab0ed1b4&scoped=true&"
import script from "./TeachRoomSiZheng2.vue?vue&type=script&lang=js&"
export * from "./TeachRoomSiZheng2.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomSiZheng2.vue?vue&type=style&index=0&id=ab0ed1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0ed1b4",
  null
  
)

export default component.exports